import React from "react";

const Sponsors = () => {
  const [showSpecialBanner, setShowSpecialBanner] = React.useState(false);

let ads = [
  {Id:1, DateCreated:'2/06/23', Title:"Become a sponsor!", Detail1:"Place your AD here.",Detail2:"", Detail3:"" , Link:"addinfo.pdf", Image:"adboard.jpg"},
  //{Id:2,DateCreated:'2/01/25',Title:"Diamond Wings Supplies",  Detail1:"An independent importer of top of the line Belgian pigeon feed,grits and minerals", Detail2:"loft and breeding supplies and much more!" , Link:"DIAMONDWINGS.pdf",Image:""},
  //{Id:3,DateCreated:'01/26/25',Title:"Tommy's Feeds", Detail1:"",Detail2:'',Detail3:"", Link:"TOMMY'S FEED FLYER 2025.pdf",Image:"tommylogo2.jpg"},
  // {Id:4,DateCreated:'9/15/22',Title:"For Sale!", Detail1:"Wicker Baskets and 4 Holes Show Cages",Detail2:'Contact Jimmy Corso 201-450-4551.',Detail3:"", Link:"",Image:""},
  //{Id:5,DateCreated:'01/18/25',Title:"Siegel Pigeons", Detail1:"",Detail2:'',Detail3:"", Link:"https://www.siegelpigeons.com/product/benzing-live-smarthub/",Image:"Benzing Smarthub 5 - SPECIAL-.jpg"},
  {Id:6,DateCreated:'01/26/26',Title:"", Detail1:"METUCHEN SHOOTOUT RACE & AUCTION",Detail2:'',Detail3:"", Link:"SKYTALKAD2026.pdf",Image:"CJCADHEADERINTRO2026.png"},
  // {Id:7,DateCreated:'6/04/23',Title:"California Classic", Detail1:"",Detail2:'',Detail3:"", Link:"CaliforniaClassicAd.png",Image:"CaliforniaLateHatchClassic.png"},
  // {Id:8,DateCreated:'10/05/23',Title:"", Detail1:"This is one auction you don't want to miss! Offering my entire collection of Wout Smeulder!",Detail2:'',Detail3:"", Link:"Ad Final 2023.jpg",Image:"Ad Final 2023small.jpg"},
  // {Id:9,DateCreated:'10/24/23',Title:"Chelsea Loft Auction", Detail1:"Chelsea Loft aquired birds from the TOP lofts like Ganus, Eijerkamp, Oscan and Linda Devries.",Detail2:'Birds available in the Auction are bred in individual cages!',Detail3:"", Link:"chelsealoftauction.pdf",Image:""},
  //{Id:10,DateCreated:'10/25/23',Title:"The Tar Heel Classic OLR", Detail1:"",Detail2:'',Detail3:"", Link:"https://www.tarheelclassicrace.com/",Image:"tarheellogo2.png"},
  //{Id:11,DateCreated:'01/26/25',Title:"", Detail1:"",Detail2:'',Detail3:"", Link:"https://www.facebook.com/YouCanCOUNTONCARLA",Image:"ReMaxDreams_Carla_Checklist.PNG"},
  //{Id:12,DateCreated:'12/15/23',Title:"Luxurious Handcrafted Soaps", Detail1:"",Detail2:'',Detail3:"", Link:"http://www.gotcocos.com",Image:"cjc_gotcoco_ad.png"},
  //{Id:13,DateCreated:'01/10/24',Title:"", Detail1:"",Detail2:'',Detail3:"", Link:"ADFROM HEADERSEEMOREINFORMATION.docx.pdf",Image:"2024qcm.JPG"},
  {Id:10,DateCreated:'12/14/26',Title:"Run by a former CJC member!", Detail1:"",Detail2:'',Detail3:"", Link:"https://www.tarheelclassicrace.com/",Image:"tarheellogo2.png"},
  //{Id:14,DateCreated:'03/02/24',Title:"", Detail1:"",Detail2:'',Detail3:"", Link:"SUPER 2024 YOUNG BIRDS.pdf",Image:"superset2024.JPG"},
  {Id:15,DateCreated:'01/18/25',Title:"We Design Logos. We Build Websites.", Detail1:"",Detail2:'',Detail3:"", Link:"https://www.charmedcoder.com/",Image:"charmedcoder.png"},
 // {Id:16,DateCreated:'03/02/25',Title:"Mulligan's Place Loft: Reduction Sale!", Detail1:"",Detail2:'',Detail3:"", Link:"mulligan.pdf",Image:"mulligan.png"},
  {Id:17,DateCreated:'09/16/25',Title:"", Detail1:"",Detail2:'',Detail3:"", Link:"LyfeConnectFlyer.png",Image:"LyfeConnectLogo.png"},
  {Id:18,DateCreated:'12/08/25',Title:"Triple D Feed", Detail1:"",Detail2:'',Detail3:"", Link:"tripleDFullAd.jpeg",Image:"tripleDFullAdlogo.png"},
  {Id:19,DateCreated:'01/02/26',Title:"2026 Perth Amboy Racing Pigeon Club Races", Detail1:"",Detail2:'',Detail3:"", Link:"2026PerthAmboyOpenRaces.pdf",Image:"paof.png"},

];


  const cardStyle = {
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    textAlign: "center",
    padding: "16px",
    transition: "transform 0.2s",
    overflow: "hidden" // prevents scaled content from spilling
  };

  const imageWrapStyle = {
    width: "100%",
    aspectRatio: "16 / 9",        // keeps a clean, consistent box
    maxHeight: 220,               // optional cap; remove if you want purely ratio-based
    marginBottom: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f2f4f7",
    borderRadius: 6,
    overflow: "hidden"
  };

  const imgStyle = {
    width: "100%",
    height: "100%",
    objectFit: "contain", // key: contain inside the box, no overflow
    display: "block"
  };

  const isAbsoluteUrl = (url) => /^(https?:)?\/\//i.test(url);

  return (
    <div style={{ fontFamily: "Arial, sans-serif", backgroundColor: "#f9f9f9" }}>
      <header style={{ backgroundColor: "#003366", color: "white", padding: "20px", textAlign: "center" }}>
        <h1>Our Valued Sponsors</h1>
        <p>Thank you to the amazing sponsors who support CJC Combine</p>
      </header>

      <section
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "20px",
          padding: "40px"
        }}
      >
        {ads.map((ad) => {
          const href = isAbsoluteUrl(ad.Link)
            ? ad.Link
            : `http://api.charmedcoder.com/UploadedFiles/cjccombine/posts/${encodeURI(ad.Link)}`;

          return (
            <div
              key={ad.Id}
              style={cardStyle}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <a href={href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
                {ad.Image && (
                  <div style={imageWrapStyle}>
                    <img
                      src={encodeURI(`../../images/${ad.Image}`)}
                      alt={ad.Title || "Sponsor Ad"}
                      style={imgStyle}
                      loading="lazy"
                    />
                  </div>
                )}
                {ad.Title && <h3 style={{ fontSize: "16px", margin: "8px 0 6px" }}>{ad.Title}</h3>}
                {ad.Detail1 && <p style={{ fontSize: "14px", color: "#555", margin: 0 }}>{ad.Detail1}</p>}
                {ad.Detail2 && <p style={{ fontSize: "14px", color: "#555", margin: 0 }}>{ad.Detail2}</p>}
                {ad.Detail3 && <p style={{ fontSize: "14px", color: "#555", margin: 0 }}>{ad.Detail3}</p>}
              </a>
            </div>
          );
        })}
      </section>
    </div>
  );
};

export default Sponsors;
